import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const affinityV2 = defineConnector({
  identifier: "affinityV2",
  name: "Affinity",
  tagLine: "Relationship intelligence CRM",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.affinity\\.co/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Find your Affinity (v2) API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Affinity API docs](https://api-docs.affinity.co/#authentication), then in Affinity go to **Settings** → **Developers** to create or copy an API key. Use the key with access to the workspace you want to connect.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Affinity (v2) account settings.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder: "nrlW2KR5m-qUCA-rTqKb_EUK1swERlenqn70KNMMrTM",
          helperText: "The API Key for your Affinity account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.affinity.co/v2/auth/whoami",
  },
});
